export const adaptSelector = (contentFields, path, language, defaultValue = '') => {
  const contentField = contentFields.find((contentField) => contentField.path === path);
  if (contentField) {
    return {
      staticValue: getValueByLang(contentField, language, defaultValue),
    };
  } else {
    return {
      staticValue: [defaultValue],
    };
  }
};

const getValueByLang = (contentField, lang, defaultValue) => {
  if (!contentField.selectedOptionsRaw) return [defaultValue];

  if (!contentField.selectedOptionsRaw[0]) return [defaultValue];

  const availableLang = contentField.selectedOptionsRaw[0].value.map((v) => v.key.toLowerCase());

  if (availableLang.includes(lang.toLowerCase())) {
    const translated = contentField.selectedOptionsRaw[0].value.find((v) => v.key.toLowerCase() === lang.toLowerCase());
    return translated.value;
  }

  const defaultLocale = contentField.selectedOptionsRaw[0].defaultLocale;
  const translated = contentField.selectedOptionsRaw[0].value.find((v) => v.key === defaultLocale);
  return translated.value;
};
